import React from 'react';
import { DashboardTemplate } from './Dashboard';
import { Button } from "components/globals/ui/input/Button";
import { FaPlus } from "react-icons/fa6";

export default function DashboardNew() {

	return (
		<DashboardTemplate title="New">

				<Button to="/new/post" variant="primary">
					<span><FaPlus /></span>
					<span>Post</span>
				</Button>

				<br /><br />

				<Button to="/new/car" variant="primary">
					<span><FaPlus /></span>
					<span>Garage Car</span>
				</Button>

				<br /><br />

				<Button to="/new/event" variant="primary">
					<span><FaPlus /></span>
					<span>Event</span>
				</Button>

				<br /><br />

				<Button to="/new/project" variant="primary">
					<span><FaPlus /></span>
					<span>Project</span>
				</Button>


		</DashboardTemplate>
	);
}